module.exports = __webpack_public_path__ + "media/logos/accesos-w300-43399d99.png";